import React from "react";
import LazyImage from "./LazyImage";

function JunkHauling() {
  return (
    <div>
      <div className="container-fluid leave-junk-pros leave-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-md-12 junk-pros">
              <h2>Leave Junk Hauling to Pros</h2>
              <h6>Turning Clutter Into Clean Spaces, Every Time!</h6>
              <div class="sliderline-svg junk-line">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="64"
                  height="4"
                  viewBox="0 0 64 4"
                  fill="none"
                >
                  <path
                    d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                    fill="#60BDFF"
                  ></path>
                </svg>
              </div>
              <h3>Free Estimates</h3>
              <div className="sliderline-svg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={64}
                  height={4}
                  viewBox="0 0 64 4"
                  fill="none"
                >
                  <path
                    d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                    fill="#60BDFF"
                  />
                </svg>
              </div>
              <p>
                You’ll always get a free, no-obligation estimate before any work
                begins
              </p>
              <h3>Same-Day or Next-Day Service</h3>
              <div className="sliderline-svg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={64}
                  height={4}
                  viewBox="0 0 64 4"
                  fill="none"
                >
                  <path
                    d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                    fill="#60BDFF"
                  />
                </svg>
              </div>
              <p>
                Perfect for homes and businesses looking to remove junk, our
                service keeps your space tidy and ready to use.
              </p>
              <h3>Five Star Service Guarantee</h3>
              <div className="sliderline-svg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={64}
                  height={4}
                  viewBox="0 0 64 4"
                  fill="none"
                >
                  <path
                    d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                    fill="#60BDFF"
                  />
                </svg>
              </div>
              <p>
                If you're not completely satisfied with any aspect of our
                service, please inform us, and we’ll make every effort to
                resolve the issue promptly.
              </p>
              <h3>Professional Junk Haulers</h3>
              <div className="sliderline-svg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={64}
                  height={4}
                  viewBox="0 0 64 4"
                  fill="none"
                >
                  <path
                    d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                    fill="#60BDFF"
                  />
                </svg>
              </div>
              <p>
                Our team consists of skilled, highly trained, and certified junk
                removal professionals equipped to handle any job. They are
                dedicated to delivering an exceptional customer experience every
                time.
              </p>
            </div>
            <div className="col-lg-5 col-md-12">
              <div className="d-flex flex-column gap-5">
                <LazyImage
                  src="/assets/img/rubbish-removal.webp"
                  alt="leave junk"
                />
                <LazyImage
                  src="/assets/img/junk-removal.webp"
                  alt="leave junk"
                  className="clean-junk"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JunkHauling;
